import { render, staticRenderFns } from "./TableColumnsSelector.vue?vue&type=template&id=4c54bc36&"
import script from "./TableColumnsSelector.vue?vue&type=script&lang=js&"
export * from "./TableColumnsSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4c54bc36')) {
      api.createRecord('4c54bc36', component.options)
    } else {
      api.reload('4c54bc36', component.options)
    }
    module.hot.accept("./TableColumnsSelector.vue?vue&type=template&id=4c54bc36&", function () {
      api.rerender('4c54bc36', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/lib/vue/components/modules/TableColumnsSelector.vue"
export default component.exports